import { useNotify } from "@library/Components";
import { EarlyAccessIntroductionModal } from "@app/Views/EarlyAccess";
import { useAppConfiguration } from "@domain/AppConfiguration";

const HAS_SWITCHED_APP_KEY = 'has-switched-app';

export function setUserHasSwitchedApp()
{
    localStorage.setItem( HAS_SWITCHED_APP_KEY, 'true' );
}

export async function useCheckIfUserHasSwitchedApp()
{

    const hasSwitched = localStorage.getItem( HAS_SWITCHED_APP_KEY );
    if( hasSwitched == null ) return;

    localStorage.removeItem( HAS_SWITCHED_APP_KEY );

    setTimeout( async () => 
    {
        const app = useAppConfiguration();
        await useNotify( "Your home dealership is now " + app.name, 'Home Dealership Updated' );
    }, 1000 );

}